import { defineComponent, openBlock, createElementBlock, createElementVNode, createTextVNode, createVNode, unref, withModifiers, withCtx } from "vue";
import { CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "preorder-banner"
};
const _hoisted_2 = {
  class: "preorder-banner__link-wrapper"
};
const _hoisted_3 = {
  class: "preorder-banner__link"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericPreorderBanner",
  emits: ["preorderBannerClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = createElementVNode("div", {
        class: "preorder-banner__title"
      }, " Pre-order ", -1)), createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = createTextVNode(" Most pre-orders ship in 30 days or less. ")), createVNode(unref(CdrLink), {
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("preorderBannerClick"), ["prevent"]))
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createTextVNode(" Learn more ")])),
        _: 1,
        __: [1]
      })])])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericPreorderBanner2.mjs.map
